var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAirtable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9893 2.62133C15.4107 2.62133 14.8293 2.736 14.2827 2.964L2.372 7.88933C1.70133 8.16667 1.71867 9.1 2.388 9.37733L14.364 14.1213C15.4132 14.5467 16.5868 14.5467 17.636 14.1213L29.612 9.37733C30.2827 9.116 30.2827 8.16667 29.628 7.88933L17.6853 2.964C17.1487 2.7371 16.5719 2.62056 15.9893 2.62133ZM31.2 10.7413C31.0984 10.742 30.9979 10.7624 30.904 10.8013L17.5547 15.9707C17.4053 16.0319 17.2775 16.136 17.1873 16.2698C17.0971 16.4037 17.0486 16.5613 17.048 16.7227V28.584C17.0493 28.7139 17.0821 28.8415 17.1437 28.9558C17.2053 29.0701 17.2938 29.1677 17.4016 29.2402C17.5094 29.3126 17.6331 29.3577 17.7623 29.3717C17.8914 29.3856 18.0219 29.3678 18.1427 29.32L31.4933 24.1333C31.643 24.0777 31.7719 23.9774 31.8626 23.846C31.9533 23.7145 32.0012 23.5583 32 23.3987V11.5373C31.9986 11.3261 31.9137 11.124 31.7638 10.9751C31.6139 10.8262 31.4113 10.7427 31.2 10.7427V10.7413ZM0.901333 10.7933C0.782951 10.7891 0.66498 10.8095 0.554838 10.8531C0.444697 10.8967 0.344767 10.9626 0.261333 11.0467C0.114667 11.1947 0 11.3733 0 11.5867V22.7267C0 23.316 0.686667 23.7093 1.21067 23.4467L9.57067 19.4387L9.98 19.2427L13.9387 17.328C14.56 17.0347 14.512 16.1173 13.8573 15.872L1.17733 10.8507C1.0898 10.8141 0.996189 10.7942 0.901333 10.792V10.7933Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAirtable);
export default __webpack_public_path__ + "static/media/icon_airtable.4bbf23e3c989272f14e2aa8c1f39ab58.svg";
export { ForwardRef as ReactComponent };